import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@jisr-hr/design-system'

const CorrectionText = ({ label, icon }) => (
  <Text
    typography="caption12"
    color="var(--color-natural-gray-dark-new)"
  >
    {icon && icon} {icon && ' '} {label}
  </Text>
)

CorrectionText.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.shape(),
}

export default CorrectionText
